/* Liveness heartbeat: a cheap periodic "I still have Atrium open" ping to the
   Presence Engine. The engine tracks who pinged recently and publishes the
   online set (app.atrium.floor.online) so the floor can show people who are
   around but not in any room/call. This does NOT write per-user Matrix state —
   it only refreshes the engine's in-memory last-seen map. */
import { matrix } from '@/lib/matrix'

// Ping faster than the engine's TTL so a missed beat (or a background-tabbed
// browser throttling timers toward once-per-minute) doesn't drop us.
const PING_MS = 30_000

let timer: ReturnType<typeof setInterval> | null = null

async function ping(): Promise<void> {
  const token = matrix.getSession()?.accessToken
  if (!token) return
  try {
    await fetch('/atrium/api/ping', {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token },
    })
  } catch {
    /* engine unreachable — next tick retries */
  }
}

export function startLiveness(): void {
  if (timer) return
  void ping() // announce ourselves immediately on boot
  timer = setInterval(() => void ping(), PING_MS)
  // A tab returning to the foreground should re-announce at once, in case the
  // browser throttled our timer while it was hidden.
  document.addEventListener('visibilitychange', onVisible)
}

function onVisible(): void {
  if (document.visibilityState === 'visible') void ping()
}

export function stopLiveness(): void {
  if (timer) clearInterval(timer)
  timer = null
  document.removeEventListener('visibilitychange', onVisible)
}
